import * as Yup from 'yup';

export const getEditPersonalDetailsSchema = () => {
  return Yup.object().shape({
    fullName: Yup.string().required('Name is required'),
    email: Yup.string()
      .email('Invalid email format')
      .matches(/^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/, 'Invalid email format')
      .required('Email is required'),
    contact: Yup.string().matches(
      /^\+?[0-9\s\-()]{7,20}$/,
      'Contact must be a valid phone number',
    ),
    dob: Yup.string(),
  });
};
export const getChangePasswordSchema = () => {
  return Yup.object().shape({
    currentPassword: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .matches(
        /^(?=.*[\d!@#$%^&*(),.?":{}|<>]).{6,}$/,
        'Contain at least one number or one special character.',
      )
      .required('Password is required'),
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .matches(
        /^(?=.*[\d!@#$%^&*(),.?":{}|<>]).{6,}$/,
        'Contain at least one number or one special character.',
      )
      .required('Password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'Passwords must match')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&(),.?":{}|<>]).*$/,
        'Use upper/lowercase, number, and symbol.',
      )
      .required('Confirm Password is required'),
  });
};
